// E-LEARNING FOR KIDS LANDING PAGE
//*******************************************************************
//*******************************************************************
//IMPORTS:
//EXTERNAL & PACKAGE 
import $ from 'jquery'
import Popper from 'popper.js'
import React from 'react'
import {graphql, Link} from 'gatsby'
//COMPONENT DEPENDENCIES
import Heading from '../../components/heading'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import PageHeader from '../../components/PageHeader'
import FullWidthImage from '../../components/FullWidthImage'
import ContentBlock from  '../../components/ContentBlock'
import TextBlock from '../../components/textblock'
import Header from '../../components/Header'
import ContentList from "../../components/ContentList"
import BodySectionAlt from '../../components/BodySectionAlt'
import ContentsTable from '../../components/ContentsTable'
import Helmet from "react-helmet"
//*******************************************************************
//*******************************************************************
const kidsLearnPage = ({data}) => {
    
    const kidsLearn = data.e_learning_for_kids.edges
    
    return (   
        
        <div>
            
            
              <Helmet>
                   <title>NJCCIC E Learning For Kids</title>
                    <meta name="description" content="NJCCIC collection of online education resources for kids"/>
            </Helmet>
            <Heading/>
            
            <Navbar/>
            
            {kidsLearn.map(({node: {page_title, image, introductory_text, content_group, content_group_general_resources, content_group_online_games, content_group_cryptography_encoding_logic, content_group_social_engineering_online_safety} }) => (
    
                <div class="container-fluid">
        
                    <PageHeader divClass="containerWidth" elementClass="pageHeader centerText" title={page_title}/>    
                    
                    <div class="container containerWidth">
                        
                        <div class="row">
        
                            <TextBlock elementClass="standardText padding introPadding" text={introductory_text}/>
                            
                        </div>
                        
                    </div>

                    <ContentsTable testClass="testClass container containerWidth grid2Container" elementClass="col-12 col-md-3 grid2 blocks block2 block2Alt" dangerousClass="standardText blockText margin btnWidth" headerStyles="header contentTitle" data={content_group} iconId="iconsGroup"/>
                    
                    <FullWidthImage id="kidsLearnBanner" src={image}/>
                    
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title="General Resources" id="general-resources"/>
                    
                    <BodySectionAlt data={content_group_general_resources}/>
        
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title="Online Games" id="online-games"/>
                    
                    <BodySectionAlt data={content_group_online_games}/>
        
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title="Social Engineering & Online Safety" id="social-engineering"/>
                    
                    <BodySectionAlt data={content_group_social_engineering_online_safety}/>   
        
                    <Header divClass="container containerWidth" styles="header contentTitle guideTitle" title="Cryptography, Encoding, & Logic" id="cryptography-encoding-logic"/>
                    
                    <BodySectionAlt data={content_group_cryptography_encoding_logic}/>
                    
                    {/*<ContentList testClass="test" divClass="container containerWidth" elementClass="col-12 standardText section" headerStyles="header leftHeader clickableHeader" data={content_list}/>*/}
                                        
                    
                        
                </div>
            
            ))}
            
        
            <Footer/>
            
        </div>    

    )    
    
}
//*******************************************************************
//******************************************************************* 
export const query = graphql`
    query {
        e_learning_for_kids: allButterPage(filter: {slug: { eq: "e-learning-for-kids" } }) {
            edges {
                node {
                    slug
                    seo_title
                    page_title 
                    image
                    image_alt_text
                    introductory_text
                    content_group {
                        section_name
                        text
                        icon
                    }
                    content_list {
                        section_name
                        text
                    }
                    content_group_general_resources {
                        icon 
                        section_name
                        preview_text
                        external_link
                    }
                    content_group_online_games {
                        icon 
                        section_name
                        preview_text
                        external_link
                    }
                    content_group_social_engineering_online_safety {
                        icon 
                        section_name
                        preview_text
                        external_link
                    }
                    content_group_cryptography_encoding_logic {
                        icon 
                        section_name
                        preview_text
                        external_link
                    }
                }
            }
        }
       
    }
`
export default kidsLearnPage
//*******************************************************************
//******************************************************************* 